import { render, staticRenderFns } from "./processItems.vue?vue&type=template&id=4cae7623&scoped=true"
import script from "./processItems.vue?vue&type=script&lang=js"
export * from "./processItems.vue?vue&type=script&lang=js"
import style0 from "./processItems.vue?vue&type=style&index=0&id=4cae7623&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cae7623",
  null
  
)

export default component.exports